export default "__VITE_ASSET__DQL$2BoJ__"